import {v4 as uuidv4} from 'uuid';
import OriginationSourcing from '../../assets/img/Service/OriginationSourcing.jpg';
import ProcessingRefining from '../../assets/img/Service/ProcessingRefining.jpg';
import ResearchDevelopment from '../../assets/img/Service/ResearchDevelopment.jpg';
import Customization from '../../assets/img/Service/Customization.jpg';
import Distribution from '../../assets/img/Service/Distribution.jpg';
import StorageWarehousing from '../../assets/img/home2/StorageWarehousing.jpg';
import OriginationIcon from '../../assets/img/icons/Origination_Sourcing.svg';
import ProcessingRefiningIcon from '../../assets/img/icons/Processing_Refining.svg';
import CustomizationIcon from '../../assets/img/icons/Customization.svg';
import Distributionicon from '../../assets/img/icons/Distribution.svg';
import StorageWarehousingIcon from '../../assets/img/icons/Storage_Warehousing.svg';
import ResearchDevelopmentIcon from '../../assets/img/icons/Research_Development.svg';


const servicesTwoData = [
    {
        id: uuidv4(),
        img: OriginationSourcing,
        icon: OriginationIcon,
        title: 'Origination & Sourcing',
        desc: 'We source high-quality raw materials, including cotton, oilseeds, grains, and pulses, from trusted suppliers.',
    },

    {
        id: uuidv4(),
        img: ProcessingRefining,
        icon: ProcessingRefiningIcon,
        title: 'Processing & Refining Edible Oil',
        desc: 'Our advanced processes produce premium edible oils, oil cakes, and de-oiled cakes for various industries.',
    },

    {
        id: uuidv4(),
        img: Customization,
        icon: CustomizationIcon,
        title: 'Processing oil cake',
        desc: 'We deliver tailored product solutions designed to meet the unique requirements of our clients worldwide.',
    },
    // {
    //     id: uuidv4(),
    //     img: Distribution,
    //     icon: Distributionicon,
    //     title: 'Distribution',
    //     desc: 'With efficient logistics, we ensure timely and seamless delivery to domestic and global markets.',
    // },
    {
        id: uuidv4(),
        img: StorageWarehousing,
        icon: StorageWarehousingIcon,
        title: 'Storage & Warehousing',
        desc: 'Our modern facilities provide secure storage for raw materials and finished products.',
    },
    {
        id: uuidv4(),
        img: ResearchDevelopment,
        icon: ResearchDevelopmentIcon,
        title: 'Processing cotton/ginning',
        desc: 'We continually innovate and enhance our offerings to set new benchmarks in the industry.',
    },
    
]

export default servicesTwoData;